var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('center',[_c('img',{attrs:{"src":"https://cofiza.com/wp-content/uploads/2023/02/logocofiza-3.png","width":"200px","height":"200px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }